import { Component, HostBinding, Input, OnChanges, SimpleChanges, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

import { INavData } from './app-sidebar-nav';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { SidebarNavService } from './app-sidebar-nav.service';
import { AppSidebarService } from './app-sidebar.service';
import { UtilitiesService } from 'src/modules/base/services/utilities.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';

@Component({
    selector: 'app-sidebar-nav, cui-sidebar-nav',
    templateUrl: './app-sidebar-nav.component.html',
    standalone: false
})
export class AppSidebarNavComponent implements OnInit, OnChanges, OnDestroy {
  // the sidebar is rebuilt with the layout shell on every module navigation
  private headerConfigSub: Subscription;
  @Input() navItems: INavData[] = [];

  @HostBinding('class.sidebar-nav') _sidebarBav = true;
  @HostBinding('attr.role') @Input() role = 'nav';
  @ViewChild("search_menu") searchMenuEle:ElementRef; 


  public navItemsArray: INavData[] = [];
  public _navItemsArray: INavData[] = [];
  public searchItemsArray: any = false;
  public _translateRes: any = {};
  public showSearchInput: boolean = true;
  public smartMenuEnabled: boolean = false;
  headerJson: any;

  constructor(
    public router: Router,
    public appService: AppService,
    public baseService: BaseService,
    public AppSidebarService?: AppSidebarService,
    public utilService?: UtilService,
    public prefereceService?:PreferenceService
  ) {
  }

  ngOnInit() {
    this.translate();
    if (this.appService.getSessionId()) {
      this.headerJson = this.appService.getAppHeader();
    }
    this.smartMenuEnabled = this.isSmartMenuEnabled();
    this.headerConfigSub = this.prefereceService.headerConfig$.subscribe(data => {
      console.log("headerConfig==>",data)
    });
  }

  ngOnDestroy() {
    this.headerConfigSub?.unsubscribe();
  }

  ngAfterViewInit(){
    fromEvent(this.searchMenuEle.nativeElement, 'keyup').pipe(debounceTime(100),
    distinctUntilChanged()
    ).subscribe(value => {
      this.searchMenu({target:{value:this.searchMenuEle.nativeElement.value}});
    })

  }

  removeSidebar() {
    if (document.body.classList.contains('sidebar-show') && this.appService.showSidebar) {
      // this.classToggler.removeClassesCustom(sidebarCssClasses);
      const cssClass = `sidebar-show`;
      // this.classToggler.toggleClasses(cssClass, sidebarCssClasses);
      document.body.classList.toggle(cssClass)
      this.appService.showSidebar = false;
      // this.cdr.detectChanges()
    }
  }
  translate() {
    this._navItemsArray = JSON.parse(JSON.stringify(this.navItemsArray));
    if (this._navItemsArray.length > 0) {
      var config: any = {};
      config.allPromiseObj = [];
      config.allPromiseTempObj = {};
      config.i = 0;
      config = this.loopSidebar(this._navItemsArray, config, 'translate');
      Promise.all(config.allPromiseObj).then((promiseResponse) => {
        config.promiseResponse = promiseResponse;
        config.i = 0;
        config = this.loopSidebar(this._navItemsArray, config, 'replace');
        console.log("this._navItemsArray", this._navItemsArray);
        this.countTotalItems();
      });

    }
  }

  countTotalItems() {
    setTimeout(() => {
      if (document.getElementsByTagName('app-sidebar-nav-link').length >= 1) {
        this.showSearchInput = true;
      } else {
        this.showSearchInput = false;
      }
    })
  }
  loopSidebar(array, config, action) {
    var arr = array.filter(item => {
      var mainLabelFound = false;
      var toBeTranslated = (item.name_translation_key? item.name_translation_key: item.name);
      if ((item.name_translation_key != undefined && item.name_translation_key) || (item.name != undefined && item.name)) {
        if (action == 'translate') {
         
          config.allPromiseTempObj[config.i] = toBeTranslated;//remembring which index of which label
        } else if (action == 'replace') {
          this._translateRes[toBeTranslated] = config.promiseResponse[config.i];
        } else if (action == 'search') {
          var label = (this._translateRes[toBeTranslated] != undefined) ? this._translateRes[toBeTranslated].toLowerCase() : '';
          var isSmartMenu = config.isSmartMenu != undefined ? config.isSmartMenu : false
          if(isSmartMenu){
            var result = this.utilService?.findSimilarStrings(config.value.toLowerCase(), label);
            item.score = result
            if (config.value != undefined && config.value != '' && result) { //smart matching
              if (item.children != undefined) {
                mainLabelFound = true;
              }
            } else {
              if (item.children == undefined || item.children.length == 0) {
                return false;
              }
            }
          }else{
            if (config.value != undefined && config.value != '' && label.indexOf(config.value.toLowerCase()) > -1) {
              if (item.children != undefined) {
                mainLabelFound = true;
              }
            } else {
              if (item.children == undefined || item.children.length == 0) {
                return false;
              }
            }
          }
            
        }

        config.i++;
        if (action == 'translate') {
          config.allPromiseObj.push(this.baseService.asyncMenuLanguageProcess(item));
        }
        if (item.children != undefined && item.children.length) {
          config = this.loopSidebar(item.children, config, action);
          if (action == 'search') {
            item.open = true;
            if (config.array.length == 0 || item.name.toLowerCase() == config.value.toLowerCase()) { //or condition added for mis menu search
              if (!mainLabelFound) {
                return false;
              }
            } else {
              item.children = config.array;
            }
          }
        }
      }
      return item;
    });
    if (action != 'search') {
      this._navItemsArray = arr;
    }
    config.array = arr;
    return config;
  }

  emptyChildren(){

  }
  public ngOnChanges(changes: SimpleChanges): void {
    this.navItemsArray = Array.isArray(this.navItems) ? this.navItems.slice() : [];
    this._navItemsArray = JSON.parse(JSON.stringify(this.navItemsArray));
    this.translate();
    this.searchItemsArray = false;
  }

  searchMenu(event) {
    if (event.target.value != '') {

      var searchVal = event.target.value.trim();
      this.searchItemsArray = JSON.parse(JSON.stringify(this._navItemsArray));
      var config: any = {};
      config = this.loopSidebar(this.searchItemsArray, { value: searchVal,isSmartMenu:this.isSmartMenuEnabled() }, 'search');
      this.searchItemsArray = config.array;
      if(this.smartMenuEnabled){
        // Now, with the filtered menu, calculate the `maxScore` for each top-level item.
        // This will set the `maxScore` property on the root nodes based on the highest
        // score found within their entire sub-tree.
        this.searchItemsArray.forEach(item => this._calculateMaxScoreRecursive(item));

        // Finally, sort the top-level array based on the new `maxScore` property in descending order.
        this.searchItemsArray = this.searchItemsArray.sort((a, b) => (b.maxScore || 0) - (a.maxScore || 0));
      }
      var sidebarEle = document.querySelector('app-sidebar-nav');
      if (sidebarEle) {
        sidebarEle.scrollTo(0, 0);
      }
    } else {
      this.searchItemsArray = false;
    }
  }
  
  private _calculateMaxScoreRecursive(item: any): number {
    // Start with the item's own score, defaulting to 0 if not present.
    let maxScore = item.score || 0;
  
    // If the item has children, recursively call this function on each child.
    if (item.children && item.children.length > 0) {
      // Recursively find and set the max score for all children first.
      for (const child of item.children) {
        maxScore = Math.max(maxScore, this._calculateMaxScoreRecursive(child));
      }
      
      // Once scores for all children are calculated, sort the children array
      // based on their new `maxScore` property in descending order.
      item.children.sort((a, b) => (b.maxScore || 0) - (a.maxScore || 0));
    }
  
    // Store the final max score on the item for its parent to use in sorting.
    item.maxScore = maxScore;
  
    return maxScore;
  }
  isArray(obj) {
    return obj instanceof Array;
  }

  Togglesearch() {
    if (document.body.classList.contains('sidebar-minimized') && document.body.classList.contains('brand-minimized') && !this.utilService.isMobile()) {
      document.body.classList.remove('sidebar-minimized');
      document.body.classList.remove('brand-minimized');
      this.AppSidebarService.toggle({ minimize: 'toggle' });
    }
  }

  toggleSmartMenu(){
      var smartMenu = !this.isSmartMenuEnabled();
      this.smartMenuEnabled = smartMenu;
      this.prefereceService.saveMenuConfig({smartMenu:smartMenu},()=>{
        this.smartMenuEnabled = smartMenu;
      })
  }
  isSmartMenuEnabled(){
    return this.prefereceService.isSmartMenuEnabled('smartMenu');
  }

}
